import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '~/shared/contexts/AuthProvider';
import { EstEstimateRequestPlanList } from './pages/EstEstimateRequestPlanList';
import { EstEstimateRequestPlanConfirmation } from './pages/EstEstimateRequestPlanConfirmation';
import { EstEstimateRequestList } from './pages/EstEstimateRequestList';
import { EstEstimateRequestInput } from './pages/EstEstimateRequestInput';
import { EstEstimateRequestConfirmation } from './pages/EstEstimateRequestConfirmation';
import { EstEstimateRequestDetailList } from './pages/EstEstimateRequestDetailList';
import { EstEstimateSelectionApprovalList } from './pages/EstEstimateSelectionApprovalList';
import { EstEstimateResultList } from './pages/EstEstimateResultList';
import { EstEstimateResultConfirmation } from './pages/EstEstimateResultConfirmation';

import { EstEstimateOriginalRequestPlanList } from './pages/original/EstEstimateOriginalRequestPlanList';
import { EstEstimateOriginalRequestPlanConfirmation } from './pages/original/EstEstimateOriginalRequestPlanConfirmation';
import { EstEstimateOriginalRequestList } from './pages/original/EstEstimateOriginalRequestList';
import { EstEstimateOriginalRequestInput } from './pages/original/EstEstimateOriginalRequestInput';
import { EstEstimateOriginalRequestConfirmation } from './pages/original/EstEstimateOriginalRequestConfirmation';
import { EstEstimateOriginalRequestDetailList } from './pages/original/EstEstimateOriginalRequestDetailList';
import { EstEstimateOriginalSelectionApprovalList } from './pages/original/EstEstimateOriginalSelectionApprovalList';
import { EstEstimateOriginalResultList } from './pages/original/EstEstimateOriginalResultList';
import { EstEstimateOriginalResultConfirmation } from './pages/original/EstEstimateOriginalResultConfirmation';

export const EstimateRoutes = () => {
  return (
    <Routes>
      <Route
        path="/est-estimate-request-plan-list"
        element={
          <RequireAuth>
            <EstEstimateRequestPlanList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-plan-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateRequestPlanConfirmation />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-list"
        element={
          <RequireAuth>
            <EstEstimateRequestList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-input"
        element={
          <RequireAuth>
            <EstEstimateRequestInput />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateRequestConfirmation />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-detail-list"
        element={
          <RequireAuth>
            <EstEstimateRequestDetailList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-request-approval-list"
        element={
          <RequireAuth>
            <EstEstimateRequestList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-selection-approval-list"
        element={
          <RequireAuth>
            <EstEstimateSelectionApprovalList />
          </RequireAuth>
        }
      />

      <Route
        path="/est-estimate-result-list"
        element={
          <RequireAuth>
            <EstEstimateResultList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-result-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateResultConfirmation />
          </RequireAuth>
        }
      />

      <Route
        path="/est-estimate-original-request-plan-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestPlanList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-plan-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestPlanConfirmation />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-input"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestInput />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestConfirmation />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-detail-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestDetailList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-request-approval-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalRequestList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-selection-approval-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalSelectionApprovalList />
          </RequireAuth>
        }
      />

      <Route
        path="/est-estimate-original-result-list"
        element={
          <RequireAuth>
            <EstEstimateOriginalResultList />
          </RequireAuth>
        }
      />
      <Route
        path="/est-estimate-original-result-confirmation/*"
        element={
          <RequireAuth>
            <EstEstimateOriginalResultConfirmation />
          </RequireAuth>
        }
      />

      <Route path="*" element={<Navigate to={{ pathname: '/' }} />} />
    </Routes>
  );
};
